import React from 'react';
import PropTypes from 'prop-types';
import { isSet } from '../../../utils/commonUtils';

const TextArea = (props) => {
  const {
    className,
    placeholder,
    value,
    style,
    disabled,
    readOnly,
    name,
    required,
    onKeyPress,
    onBlur,
    ref,
    rows
  } = props;

  const { changeHandler } = props;

  const onChangeHandler = (e) => {
    changeHandler(e.target.value, {e});
  };

  return (
    <textarea
      className={className}
      name={name}
      id={isSet(props.id,name)}
      placeholder={placeholder}
      value={value}
      style={{...style}}      
      disabled={disabled}
      readOnly={readOnly}
      onChange={(e) => onChangeHandler(e)}
      onKeyDown={onKeyPress}
      required={required}
      onBlur={onBlur}
      ref={ref}
      rows={rows}
    />
  );
};

TextArea.defaultProps = {
  className: 'form-control',
  placeholder: '',
  disabled:false,
  readOnly:false,
  value: '',
  style: {},
  required:false,
  onBlur:()=>{},
  ref:null,
  rows:""
};

TextArea.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  style: PropTypes.object,
  changeHandler: PropTypes.func.isRequired,
};

export default TextArea;
